// Režim docházky přihlášeného člověka (219) — stejné pravidlo jako na serveru
// (services.effective_attendance_mode): osobní režim > výchozí režim firmy > „na stavbě".
// Úvod ho zná hned z přihlášení, bez čekání na /daysheet/current. Server ho vrací
// i v /me/overview (`attendance_mode`) — kdyby se mezitím změnil, úvod se podle něj opraví.
const OK = (m) => m === "site" || m === "daysheet";

export function effectiveAttendanceMode(user, company) {
  if (OK(user?.attendance_mode)) return user.attendance_mode;
  if (OK(company?.attendance_mode_default)) return company.attendance_mode_default;
  return "site";
}

// Oprava odhadu podle serveru: vrací režim, který má platit po načtení /me/overview.
export function correctedMode(current, overview) {
  const m = overview?.attendance_mode;
  return OK(m) && m !== current ? m : current;
}
